import "./App.css";
import React, { useState, useEffect } from "react";
import RoodNavigation from "./routers";
import NetworkIssue from "./components/networkIssue";
// import BarChart from "./BarChart";

function App() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isIframe, setIsIframe] = useState(false);

  useEffect(() => {
    // useEffect(() => {
    // const isEmbedded = window.top !== window.self;
    // if (isEmbedded) {
    //   window.top.location = window.location.href;
    // }
    // }, []);
    // if (window.self !== window.top) {
    //   window.top.location.href = null;
    //   window.top.location.href = window.self.location.href;
    // }

    // if (window.top !== window.self && window.location.pathname != `./HISTORICAL CROPPING PATTERN.pdf`) {
    //   setIsIframe(true);
    // }
    // if (window.top !== window.self) {
    //   // Check if the current page is not the PDF
    //   if (window.location.pathname !== './HISTORICAL CROPPING PATTERN.pdf') {
    //     setIsIframe(true);
    //   }
    // }

    if (window.self !== window.top) {
      // Check if the current page is not the PDF
      // if (window.location.pathname !== './HISTORICAL CROPPING PATTERN.pdf' && window.location.pathname !== '/acz_cropplanning') {
      // if(!window.location.pathname.split(".").includes("pdf") && window.location.pathname !== '/acz_cropplanning') {
      // Redirect to the top window
        // window.top.location = window.location.href;
                setIsIframe(true);
      // }
    }
    
    const handleOnlineStatusChange = () => {
      setIsOnline(navigator.onLine);
    };

    window.addEventListener("online", handleOnlineStatusChange);
    window.addEventListener("offline", handleOnlineStatusChange);

    return () => {
      window.removeEventListener("online", handleOnlineStatusChange);
      window.removeEventListener("offline", handleOnlineStatusChange);
    };

    // Example usage: Pass your preferred font size (e.g., 16px)
  }, []);

  return (
    <div>
      {isIframe ? (
        <img src="/error_page.svg" alt="Blocked Content" />
      ) : isOnline ? (
        <RoodNavigation />
      ) : (
        <NetworkIssue />
      )}
    </div>
  );
}

export default App;
